/** A `wa.me` link, to a number when it is known, else to whoever the broker picks in WhatsApp. */
export function whatsappLink(text: string, phone?: string | null): string {
  const digits = (phone ?? '').replace(/\D/g, '');
  const to = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${to}?text=${encodeURIComponent(text)}`;
}

export function memoShareText(input: {
  party: string;
  propertyTitle: string;
  agency: string;
  link: string;
}): string {
  return `Hello, ${input.agency} has sent the brokerage memo for ${input.propertyTitle} for the ${input.party}. Please read it and sign with a code: ${input.link}`;
}
